export const MAP_TOOLTIP_CARD_HEIGHT_IN_STEPS = 34;
